import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav",
  "use": "icon-nav-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"icon-nav\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#D91313\" y=\"10\" width=\"12\" height=\"4\" rx=\"2\" /><rect fill=\"#333\" width=\"18\" height=\"4\" rx=\"2\" /><rect fill=\"#333\" y=\"20\" width=\"18\" height=\"4\" rx=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol